<template>  
	<svg>
		<use :xlink:href="'#' + use" />
	</svg>
</template>

<script>
export default {
	name: 'icon',
	props: [
		'use'
	]
}
</script>


// WEBPACK FOOTER //
// icons.vue?7fa92a0b